<template>
    <RemoteTable ref="table" :form="form" :table="table">
        <template #default="{row, property}">
            <template v-if="property === 'code'">
                {{$root.getBusinessName(row.code)}}
            </template>
            <template v-else-if="property === 'channel'">
                {{getChannelName(row.channel)}}
            </template>
            <el-switch v-else-if="property === 'status'"
                       v-model="row.status.value" @change="changeStatus(row.id, $event)"
                       active-value="enable" inactive-value="disable"></el-switch>
        </template>
    </RemoteTable>
</template>

<script>
    import RemoteTable from '@/components/RemoteTable'

    export default {
        components: {
            RemoteTable
        },
        data() {
            return {
                form: {
                    configs: [
                        {label: "业务", name: "code", type: "cascade", op: "beginwith", value: ""},
                        {label: "类型", name: "type", type: "select", value: "", url: "/dict/list/route/type"},
                        {label: "通道", name: "channel", type: "select", value: "", options: []},
                        {label: "状态", name: "status", type: "select", value: "", url: "/dict/list/public/status"},
                    ],
                    tools: [
                        {
                            icon: "el-icon-plus", click: () => {
                                this.$router.push("/route/0")
                            }
                        },
                        {
                            label: "导出",
                            click: () => {
                              this.$confirm("确认进行导出操作？", "提示", {
                                confirmButtonText: "确认",
                                cancelButtonText: "取消",
                                type: 'warning'
                              }).then(() => {
                                this.$axios.post('/route/download', this.$refs.table.getQueryInfo()).then(response => {
                                  this.$utils.download("/file/pop/" + response);
                                });
                              });
                            }
                        }
                    ]
                },
                table: {
                    urlPrefix: "/route",
                    columns: [
                        {label: "业务名称", name: "code"},
                        {label: "通道", name: "channel", width: 400},
                        {label: "权重", name: "weight", width: 50},
                        {label: "类型", name: "type", width: 80},
                        {label: "状态", name: "status", width: 80},
                        {label: "创建时间", name: "createTime", width: 150},
                    ],
                    tools: [
                        {icon: "el-icon-edit", content: "编辑", click: (row) => {this.$router.push("/route/" + row.id)}}
                    ],
                },
                channels: []
            }
        },
        mounted() {
            let options = [];
            this.$axios.post("/channel/list").then(results => {
                results.forEach(result => {
                    options.push({value: result.code, label: result.name});
                });

                this.$set(this.form.configs[2], 'options', options);
                this.channels = options;
            });
        },
        methods: {
            getChannelName(val) {
                let name = "";
                this.channels.forEach(option => {
                    if (val === option.value) {
                        name = option.label;
                        return false;
                    }
                });
                return name;
            },
            changeStatus(id, status) {
                this.$axios.post("/route/edit", {
                    id: id,
                    status: {value: status}
                }).then((result) => {
                    this.$utils.handleResult(result, () => {
                        this.$refs.table.load();
                    })
                })
            },
        }
    }
</script>